// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skl-card {
  border: 1px solid #dee2e6;
  border-radius: 4px;
  background: #fff;
}

.skl-card--spaced {
  margin-top: 20px;
}

.skl-card__body {
  padding: 20px;
}

.skl-table-wrap {
  border: 1px solid #edf0f2;
  border-radius: 4px;
  overflow: hidden;
}

.skl-row {
  display: grid;
  grid-template-columns: 1.7fr 1fr 1fr 0.9fr 1fr 0.8fr;
}

.skl-row--header {
  background: #f8f9fa;
}

.skl-row--data + .skl-row--data {
  border-top: 1px solid #edf0f2;
}

.skl-cell {
  display: flex;
  align-items: center;
  min-height: 52px;
  padding: 12px 16px;
}

.skl-form-row {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 20px;
}

.skl-form-col {
  min-width: 0;
}

@media (max-width: 991.98px) {
  .skl-row {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .skl-form-row {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 575.98px) {
  .skl-form-row {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./projects/ai_modernization/src/app/admin/roles-privileges/roles-privileges-skeleton/roles-privileges-skeleton.component.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,oDAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,6BAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE;IACE,gDAAA;EACF;EAEA;IACE,gDAAA;EAAF;AACF;AAGA;EACE;IACE,0BAAA;EADF;AACF","sourcesContent":[".skl-card {\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  background: #fff;\n}\n\n.skl-card--spaced {\n  margin-top: 20px;\n}\n\n.skl-card__body {\n  padding: 20px;\n}\n\n.skl-table-wrap {\n  border: 1px solid #edf0f2;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.skl-row {\n  display: grid;\n  grid-template-columns: 1.7fr 1fr 1fr 0.9fr 1fr 0.8fr;\n}\n\n.skl-row--header {\n  background: #f8f9fa;\n}\n\n.skl-row--data + .skl-row--data {\n  border-top: 1px solid #edf0f2;\n}\n\n.skl-cell {\n  display: flex;\n  align-items: center;\n  min-height: 52px;\n  padding: 12px 16px;\n}\n\n.skl-form-row {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 20px;\n}\n\n.skl-form-col {\n  min-width: 0;\n}\n\n@media (max-width: 991.98px) {\n  .skl-row {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n\n  .skl-form-row {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 575.98px) {\n  .skl-form-row {\n    grid-template-columns: 1fr;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
